<template>
    <div id = "fg-settings" :class = "[{'settings-modal-wrapper':true}, {'info-active':activeItem==='Info'}]" v-on:click.self.prevent>
        <div class="settings-fader w-100 h-100" @click="close">
        </div>
        <div>
            <div id="settings-modal" class="settings-modal" v-if="activeItem!=='Volume'">
                <div class="title d-flex align-items-center justify-content-start">
                    <div v-if="menuItems[activeItem].menuIcon" class = "tab-icon d-flex align-items-center h-100 justify-content-center">
                        <img :src="`/fg/v2/img/icons/${menuItems[activeItem].menuIcon}.svg`" alt="Settings">
                    </div>

                    <div v-if="menuItems[activeItem].title" class="active-tab-name pl-md-3 pr-md-3 h-100 d-flex align-items-center justify-content-center">
                        <span class="top-line w-100"></span>                    
                        {{menuItems[activeItem].title}}
                    </div>

                    <div v-if="menuItems[activeItem].subItems" class="subitems d-flex h-100">
                        <div v-for="(subItem, subItemIndex) in menuItems[activeItem].subItems" :key="subItemIndex"
                            :class="[{'active-tab-name' : activeSubItem ===  subItem['name']}, 
                            {'subitem h-100 d-flex align-items-center justify-content-center' : true}]"
                            @click = "activeSubItem = subItem['name']" v-if="!subItem.hide" >  
                            <span v-if="activeSubItem ===  subItem['name']" class="top-line w-100"></span>           
                            <div class = "pl-2 pr-2 pl-md-3 pr-md-3">{{subItem.title}}</div>      
                            <span v-if = "subItem['name'] != activeSubItem 
                            && (menuItems[activeItem].subItems[subItemIndex + 1] 
                            && activeSubItem != menuItems[activeItem].subItems[subItemIndex + 1]['name']) " class="separator"></span>
                        </div>
                    </div>

                    <div class="h-100 flex-grow-1 space-keeper"></div>
                    
                    <div class = "ml-auto close-icon h-100 d-flex align-items-center justify-content-center" @click="close">
                        <img src="/fg/v2/img/icons/icon_cross.svg" alt="Close">
                    </div>
                </div>
                <div class="content p-2 p-md-4 w-100">
                    <Info v-if="activeItem==='Info'" :activeSubItem="activeSubItem"></Info>
                    <GameAdjustments v-if="activeItem==='Settings'"></GameAdjustments>
                </div>
            </div>
            <Volume v-if="activeItem==='Volume'" :class="isSingleAmount ? 'single-amount' : ''"></Volume>
            <div id="settings-menu" class = "d-flex align-items-center flex-md-row flex-md-column pt-2 pb-2">
                <div v-for="(item, index) in menuItems" v-if="!item.hide" :key="index" :class="`item w-md-100 text-center d-flex d-block-md align-items-center order-${item['order']} order-md-${item['order-md']}`" 
                        @mouseover="item.hover = true" @mouseleave="item.hover = false"
                        @click="item.method()">
                    <img :src="getIcon(item)" :alt="item['name']" class="img-fluid p-2">
                    <span v-if = "item['name'] != 'settings'" class="separator"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex';

import Info from '@fg/base/components/partials/settings/subitems/info/Base';
import GameAdjustments from '@fg/base/components/partials/settings/subitems/GameAdjustments';
import Volume from '@fg/base/components/partials/settings/Volume';

let paytableExists = false;

try {
    require(`@fg/base/components/partials/settings/subitems/info/paytable/${Config.game_name}`);
    paytableExists = true;
} catch (e) {}

export default {
    components: {Info, GameAdjustments, Volume},

    props: [],

    data() {
        return {
            gameName: Config.game_name.toLowerCase(),
            homePage: Config.homePage,
            menuItems: {
                "Home" : {
                    "name": "Home",
                    "hover": false,
                    "method": this.goHome,
                    "order":3,
                    "order-md":0,
                    "hide" : Config.homePage ? false : true
                },
                "Volume" : {
                    "name": "Volume",
                    "hover": false,
                    "method": this.showVolume,
                    "order":2,
                    "order-md":1
                },
                "Info" : {
                    "name": "Info",
                    "hover": false,
                    "method": this.showInfo,
                    "menuIcon": "icon_info",
                    "order":1,
                    "order-md":2,
                    "subItems": 
                    [
                        {
                            "name": "AboutGame",
                            "title": this.$options.filters.lang('about_game')
                        },
                        {
                            "name": "Paytable",
                            "title": this.$options.filters.lang('paytable'),
                            "hide": !paytableExists
                        },
                        {
                            "name": "Tickets",
                            "title": this.$options.filters.lang('tickets'),
                            "hide": !Config.fg_show_history,
                        }
                    ]
                },
                "Settings" : {
                    "name": "Settings",
                    "title": this.$options.filters.lang('game_adjustments'),
                    "hover": false,
                    "method": this.showSettings,
                    "menuIcon": "icon_ajustments",
                    "order":0,
                    "order-md":3,
                    "hide": Config.amounts.length == 1,
                }
            },
            activeItem : Config.amounts.length == 1 ? "Info" : "Settings",
            activeSubItem : Config.amounts.length == 1 ? "AboutGame" : false
        }
    },

    methods: {
        ...mapMutations(['setVolume']),

        close() {
            this.$emit('hidden');
        },
        getIcon(item) {
            switch(item.name) {
                case "Home":
                    return this.homeIcon(item);
                case "Volume":
                    return this.volumeIcon(item);
                case "Info":
                    return this.infoIcon(item);
                case "Settings":
                    return this.settingsIcon(item);
            }
        },
        homeIcon(item) {
            if(this.activeItem != item.name && !item.hover) {
                return "/fg/v2/img/icons/icon_home.svg";
            }

            return "/fg/v2/img/icons/icon_home-active.svg";
        },
        volumeIcon(item) {
            let icon = 'icon_volume-on';

            if(this.mute) {
                icon ='icon_volume-off';
            } else if (this.volume < 1) {
                icon ='icon_volume-on-middle';
            }

            if(this.activeItem != item.name && !item.hover) {
                return `/fg/v2/img/icons/${icon}.svg`;
            }

            return `/fg/v2/img/icons/${icon}-active.svg`;
        },
        infoIcon(item) {
            if(this.activeItem != item.name && !item.hover) {
                return "/fg/v2/img/icons/icon_info.svg";
            }

            return "/fg/v2/img/icons/icon_info-active.svg";
        },
        settingsIcon(item) {
            if(this.activeItem != item.name && !item.hover) {
                return "/fg/v2/img/icons/icon_ajustments.svg";
            }

            return "/fg/v2/img/icons/icon_ajustments-active.svg";
        },
        goHome() {
            window.top.location.href = this.homePage;
        },
        showVolume() {
            if (this.activeItem !== 'Volume' && this.volume === 0) {
                this.setVolume(0.25)
            } else if (this.activeItem === 'Volume') {
                if (this.volume > 0) {
                    this.setVolume(0)
                } else {
                    this.setVolume(0.25)
                }
            }

            this.activeItem = 'Volume';
        }, 
        showInfo() {
            this.activeSubItem = "AboutGame";
            this.activeItem = 'Info';
        }, 
        showSettings() {
            this.activeItem = 'Settings';
        }
    },
    computed: {
        ...mapState([
            'mute',
            'volume'
        ]),

        isSingleAmount() {
            return Config.amounts.length == 1;
        },
    }
}
</script>
